/* Native scrolling only. Mutations remain with the shared cart controllers. */
(() => {
  if (window.__fateCartDesign) return;
  window.__fateCartDesign = true;
  document.addEventListener('dialog:open', event => {
    const dialog=event.target.querySelector?.('.cart-drawer__dialog[data-fate-cart-design]');
    if(dialog){dialog.tabIndex=-1;dialog.focus({preventScroll:true});}
  },true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-recs-prev], [data-recs-next]');
    if (!button) return;
    const grid = button.closest('.cart-recs')?.querySelector('[data-cart-recs-grid]');
    if (!grid) return;
    grid.scrollBy({left:(button.hasAttribute('data-recs-prev')?-1:1)*Math.max(140,grid.clientWidth-40),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
})();
